<template lang="html">
  <div id="amenities-page" class="contained-height">
    <router-view></router-view>
    <amenities-nav></amenities-nav>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import AmenitiesNav from './AmenitiesNav';

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      slides: state => state.amenities.slides
    })
  },
  methods: {
    ...mapMutations({
      setPageReady: 'ui/setPageReady'
    }),
  },
  mounted() {
    this.setPageReady(true);
  },
  beforeDestroy() {
    this.setPageReady(false);
  },
  components: {
    'amenities-nav': AmenitiesNav
  }
};
</script>

<style lang="scss" scoped>
#amenities-page {
  padding-top: 0;
  background-color: var(--background);
}

#amenities-scale-model, #scale-model {
  height: 100%;
  width: 100%;
}

.model-debug {
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  color: black;
}

.interact-instructions {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.interact-instructions-text {
  width: 130px;
  position: relative;
  color: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: hsla(0, 0, 0, 0.8);
  border-radius: 0.25rem;
}

#amenities-lightbox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

#amenities-slides {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: var(--background);
  padding-bottom: 50px;
}

.btn-close {
  position: absolute;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 999;
  color: var(--text);
  font-size: 0.8rem;

  &:hover {
    text-decoration: underline;
  }
}

.grid-item {
  height: 200px;
  width: calc(100vw / 5);
  display: flex;

  .grid-img {
    width: 100%;
    height: 200px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
}

.amenities-close {
  color: var(--branding);
  bottom: 110px;
  left: 30px;
  z-index: 5;
  i {
    font-size: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/AmenitiesPage/AmenitiesPage.vue